import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { useBreakpoint } from 'shared/lib';
import { router } from 'shared/routing';
import { playerPageModel } from '../../model';
import cls from './player-page-heading.module.scss';

export const PlayerPageHeading = () => {
	const [name, back] = useUnit([playerPageModel.$playerName, router.back]);

	const md = useBreakpoint('md');

	return (
		name !== null && (
			<div className={cls.playerPageHeading}>
				<ActionIcon
					variant='outline'
					onClick={back}
				>
					<ChevronLeft />
				</ActionIcon>
				<Title
					order={1}
					size={md ? 'h1' : 'h3'}
					className={cls.playerPageHeadingTitle}
				>
					{name}
				</Title>
			</div>
		)
	);
};
